import { render } from "./NetworkError.vue?vue&type=template&id=5bd6af09"
const script = {}
script.render = render

export default script